module.exports = __webpack_public_path__ + "img/class1.1ec8c6a1.png";